import { devConfig } from "@/api/apiAuth";

import { fetchUrl } from "@/utils/chart/fetch_chart_api.js";
import PmChartOptions from "@/js/chart/premium/premium_chart_options.js";
import {
  getLabelSignalTest,
  getRlsSignalTest,
  getHighLineTest,
  getLowLineTest,
} from "@/api/apiChart.js";
import GoyaDominance from "@/components/dominance/chart/GoyaDominance.vue";
let pmChartInstance = new PmChartOptions();
export default class PmChartAPI {
  constructor() {
    this._baseUrl = devConfig.baseUrl;
    this.candleLoad = false;
    this.heikinLoad = false;
    this.candleData = null;
    this.heikinData = null;
    this.ao = null;
    this.aoHei = null;
    this.pink = null;
    this.pinkHei = null;
    this.markerSar = [];
    this.markerSignal = null;
    this.none = [];
    this.rls_none = [];
    this.vol = [];
    this.du = [];
    this.voldu = [];
    this.noneFiltered = [];
    this.volFiltered = [];
    this.duFiltered = [];
    this.volduFiltered = [];
    this.ma1 = null;
    this.ma2 = null;
    this.ma3 = null;
    this.ma1Hei = null;
    this.ma2Hei = null;
    this.ma3Hei = null;
    this.upper = null;
    this.lower = null;
    this.upperHei = null;
    this.lowerHei = null;
    this.trend_upper = null;
    this.trend_middle = null;
    this.trend_lower = null;
    this.trend_upper52 = null;
    this.trend_middle52 = null;
    this.trend_lower52 = null;
    this.trend_upper100 = null;
    this.trend_middle100 = null;
    this.trend_lower100 = null;
    this.priceLines = {};
    this.priceLinesData = null;
    this.orange_line = null;
    this.blue_line = null;
    this.macd = null;
    this.orange_lineHei = null;
    this.blue_lineHei = null;
    this.macdHei = null;
    this.rsi = null;
    this.rsiHei = null;
    this.rsiPriceLine = {
      rsiPrice30: null,
      rsiPrice50: null,
      rsiPrice70: null,
    };
    this.highLowLine = null;
    this.aoPriceLine = null;
  }
  async getCandle(kind, series, isHeikin) {
    // console.log('clientCountry',clientCountry);
    let coinType = "candle";

    let transformUrl = isHeikin
      ? `/${coinType}/heikin-candle`
      : `/${coinType}/candle`;
    let isCandleLoad = await this.isCandleLoad(isHeikin);
    if (
      isCandleLoad ||
      (isHeikin && !this.heikinData) ||
      (!isHeikin && !this.candleData)
    ) {
      let data = await fetchUrl(transformUrl, kind);
      // console.log('data',data);
      let candleData = data.map(({ time, open, high, low, close }) => ({
        time,
        open,
        high,
        low,
        close,
      }));

      let pinkData = data.map(({ time, pink: value }) => ({ time, value }));
      let aoData = this.caculateAO(candleData);
      // console.log('aoData',aoData);

      series.setData(candleData);
      if (isHeikin) {
        this.heikinData = candleData;
        this.pinkHei = pinkData;
        this.aoHei = aoData;
      } else {
        this.candleData = candleData;
        this.pink = pinkData;
        this.ao = aoData;
      }
    } else {
      if (isHeikin) {
        // console.log('this.heikinData',this.heikinData);
        series.setData(this.heikinData);
      } else {
        // console.log('this.candleData',this.candleData);
        series.setData(this.candleData);
      }
    }
  }
  async getIndicator(kind, isHeikin, chartObj) {
    let { url, series, key } = chartObj;
    // if (key == "PREMIUMCHANNEL") {
    //   key = "PINK";
    // }

    let initLoad = await this.isInitLoad(series, isHeikin, key);

    // console.log('getIndicator','isInitLoad',initLoad,key);
    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);

      let data = await fetchUrl(transformUrl, kind);

      let filedGroup = Object.keys(data[0]);
      // console.log('filedGroup',filedGroup);

      // if(key == 'PINk'){
      //     filedGroup = filedGroup.filter((filed)=> filed != 'time' && filed != 'open' && filed != 'high' && filed != 'low' && filed != 'close')
      // }else {
      // filedGroup = filedGroup.filter((filed)=> filed != 'time')
      // }
      filedGroup = filedGroup.filter((filed) => filed != "time");

      filedGroup.forEach((filed, index) => {
        let result = data.map(({ time, [filed]: value }) => ({ time, value }));
        if (isHeikin) {
          this[filed + "Hei"] = this[filed + "Hei"];
          this[filed + "Hei"] = result;
          // console.log('this.upperHei',this.upperHei);
        } else {
          this[filed] = result;
          // console.log('this[filed]',this[filed],filed);
        }
        series[index].name.setData(result);
      });
    } else {
      await this.getSeiresData(series, isHeikin, key);
      if (key == "AO") {
        this.aoPriceLine = pmChartInstance.getAOPriceLine();
        series[0].name.createPriceLine(this.aoPriceLine);
      }
    }
  }
  async getTrendLine(kind, chartObj) {
    let { url, series, key } = chartObj;
    let initLoad = await this.isInitLoad(series, false, key);
    if (initLoad) {
      let data = await fetchUrl(url, kind);
      series.forEach((filed) => {
        if (filed.value == "52") {
          // filed.name.setData(data["52"][filed.key]);
          // console.log("data['52'][filed.key]",data['52'][filed.key]);
          let convertedData = data["52"][filed.key].map((item) => ({
            time: item.time,
            value: parseFloat(item.value), //  숫자로 변환
          }));
          filed.name.setData(convertedData);

          this["trend_" + filed.key + "52"] = convertedData;
        } else if (filed.value == "100") {
          let convertedData = data["100"][filed.key].map((item) => ({
            time: item.time,
            value: parseFloat(item.value), //  숫자로 변환
          }));
          filed.name.setData(convertedData);
          this["trend_" + filed.key + "100"] = convertedData;
        }
      });
    } else {
      await this.getSeiresData(series, false, key);
    }
  }
  async getSr(url, kind, container, checked) {
    if (Object.keys(this.priceLines).length > 0) {
      for (let key of Object.keys(this.priceLines)) {
        container.removePriceLine(this.priceLines[key]);
        delete this.priceLines[key];
      }
    }
    if (checked) {
      if (this.priceLinesData == null) {
        let data = await fetchUrl(url, kind);
        this.priceLinesData = data;
        // console.log('data',data);
      }
      for (let key of Object.keys(this.priceLinesData)) {
        this.priceLines[key + "lines"] = container.createPriceLine({
          price: this.priceLinesData[key],
          color: this.setPriceConfig(key).color,
          lineWidth: 2,
          lineStyle: 2, // LineStyle.Dashed
          axisLabelVisible: true,
          title: this.setPriceConfig(key).title,
        });
      }
    }
  }
  async getMACD(kind, isHeikin, chartObj, forRsi = false) {
    let { url, series, key } = chartObj;
    let initLoad = await this.isInitLoad(series, isHeikin, key);
    // console.log('initLoad',initLoad,'macd',this.macd,'hei',this.macdHei);

    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);
      let data = await fetchUrl(transformUrl, kind);
      // console.log('data',data);

      let filedGroup = Object.keys(data[0]);
      filedGroup = filedGroup.filter(
        (filed) => filed != "time" && filed != "macd_color"
      );
      filedGroup.forEach((filed, index) => {
        let result;
        if (filed == "macd") {
          result = data.map(({ time, macd_color, macd }) => ({
            time,
            color: this.getHistogramColor(macd, macd_color),
            value: macd,
          }));
        } else {
          result = data.map(({ time, [filed]: value }) => ({ time, value }));
        }
        if (isHeikin) {
          this[filed + "Hei"] = this[filed + "Hei"];
          this[filed + "Hei"] = result;
        } else {
          this[filed] = result;
        }
        if (!forRsi) {
          series[index].name.setData(result);
        }
      });
    } else {
      await this.getSeiresData(series, isHeikin, key);
    }
  }
  async getRSI(kind, isHeikin, chartObj) {
    let { url, series, key } = chartObj;
    let initLoad = await this.isInitLoad(series, isHeikin, key);
    let RSIline = series[0].name;
    if (initLoad) {
      let transformUrl = this.setRequestUrl(isHeikin, key, url);

      let data = await fetchUrl(transformUrl, kind);
      if (isHeikin) {
        series.forEach((filed) => {
          // console.log("filed['key']",filed['key'],'this.blue_lineHei',this.blue_lineHei);
          if (filed["key"] == "rsi") {
            let result = data.map(({ time, heikin }) => ({
              time,
              value: parseFloat(heikin),
            }));
            filed.name.setData(result);
            this[filed.key + "Hei"] = result;
          } else {
            filed.name.setData(this[filed["key"] + "Hei"]);
          }
        });
      } else {
        series.forEach((filed) => {
          // console.log("filed['key']",filed['key']);

          if (filed["key"] == "rsi") {
            let result = data.map(({ time, candle }) => ({
              time,
              value: parseFloat(candle),
            }));
            filed.name.setData(result);
            this[filed["key"]] = result;
          } else {
            filed.name.setData(this[filed["key"]]);
          }
        });
      }
    } else {
      await this.getSeiresData(series, isHeikin, key);
    }
    if (Object.keys(this.rsiPriceLine).length > 0) {
      for (let key of Object.keys(this.rsiPriceLine)) {
        let RSIline = series[0].name;
        // console.log('key',key,'this.rsiPriceLine',this.rsiPriceLine,this.rsiPriceLine[key],'RSIline',RSIline);
        if (this.rsiPriceLine[key]) {
          RSIline.removePriceLine(this.rsiPriceLine[key]);
          delete this.rsiPriceLine[key];
          // console.log('reset indicator rsi',this.rsiPriceLine);
        }
      }
    }
    let priceList = ["rsiPrice30", "rsiPrice50", "rsiPrice70"];
    for (let i = 0; i < priceList.length; i++) {
      let rsiPriceLineOption = await pmChartInstance.getRSIPriceLine(
        priceList[i]
      );
      // console.log('rsiPriceLineOption',rsiPriceLineOption);

      if (rsiPriceLineOption) {
        this.rsiPriceLine[priceList[i]] = await RSIline.createPriceLine(
          rsiPriceLineOption
        );
      } else {
        console.log("rsi price line 생성 실패");
      }
    }
  }

  async resetIndicator(series) {
    series.forEach((filed, index) => {
      filed.name.setData([]);
    });
    if (series[0].key == "rsi") {
      // rsi priceline 30,50,70 delete
      if (Object.keys(this.rsiPriceLine).length > 0) {
        for (let key of Object.keys(this.rsiPriceLine)) {
          let RSIline = series[0].name;
          if (this.rsiPriceLine[key]) {
            RSIline.removePriceLine(this.rsiPriceLine[key]);
            delete this.rsiPriceLine[key];
            // console.log('reset indicator rsi',this.rsiPriceLine);
          }
        }
      }
    }
  }
  async updateChart(fetchList) {
    // 각 fetchllist 데이터 초기화
    this.candleData = null;
    this.heikinData = null;
    this.priceLinesData = null;
    this.markerSar = [];
    this.none = [];
    fetchList.forEach(async (ob) => {
      if (ob.series && ob.series.length > 0) {
        await this.resetIndicatorData(ob.series, ob.key);
      }
    });
  }
  async resetIndicatorData(series, key) {
    series.forEach((filed) => {
      if (key == "VOLV") {
        if (filed.value == "52") {
          this["trend_" + filed["key"] + "52"] = null;
        } else {
          this["trend_" + filed["key"] + "100"] = null;
        }
      } else {
        this[filed["key"]] = null;
        this[filed["key"] + "Hei"] = null;
        // console.log(filed['key'],this[filed['key']]);
      }
    });
  }
  async isInitLoad(series, isHeikin, key) {
    // console.log('series',series,'key',key);

    return series.some((filed) => {
      // some => 조건 하나라도 충족시 true , 아니면 false 반환하고 중단됨
      // console.log('key',key);

      if (isHeikin) {
        // console.log("this[filed[key]+'Hei']",this[filed['key']+'Hei']);
        return this[filed["key"] + "Hei"] == null;
      } else {
        if (key == "VOLV") {
          // console.log("this['trend_'+filed['key']+'52'] ",this['trend_'+filed['key']+'52'],'trend_'+filed['key']+'52' );

          return this["trend_" + filed["key"] + "52"] == null;
        } else {
          // console.log("filed['key']",filed['key']);
          return this[filed["key"]] == null;
        }
      }
    });
  }
  async getSeiresData(series, isHeikin, key = "") {
    if (isHeikin) {
      return series.forEach((filed) => {
        // console.log(filed['key']+"Hei");
        filed.name.setData(this[filed["key"] + "Hei"]);
      });
    } else {
      return series.forEach((filed) => {
        if (key == "VOLV") {
          if (filed.value == "52") {
            filed.name.setData(this["trend_" + filed["key"] + "52"]);
          } else {
            filed.name.setData(this["trend_" + filed["key"] + "100"]);
          }
        } else {
          filed.name.setData(this[filed["key"]]);
        }
      });
    }
  }
  async isCandleLoad(isHeikin) {
    if (isHeikin) {
      return this.heikinData === null;
    } else {
      return this.candleData === null;
    }
  }
  setRequestUrl(isHeikin, key, url) {
    // console.log('key', key);
    let coinType = "candle";
    if (key == "VOLV" || key == "SR" || key == "DU" || key == "RSI") {
      return url;
    } else {
      let baseUrl = isHeikin ? `/${coinType}/heikin-` : `/${coinType}/candle-`;
      let requestUrl = `${baseUrl}${url}`;

      return requestUrl;
    }
  }
  setPriceConfig(key) {
    let color;
    let title;
    color = key.startsWith("h") ? "#C11C1C" : "#00890E";

    if (key.endsWith("1d")) {
      title = key.startsWith("h") ? "RES1" : "SUP1";
    } else if (key.endsWith("2d")) {
      title = key.startsWith("h") ? "RES2" : "SUP2";
    } else if (key.endsWith("1w")) {
      title = key.startsWith("h") ? "RES3" : "SUP3";
    } else if (key.endsWith("2w")) {
      title = key.startsWith("h") ? "RES4" : "SUP4";
    } else if (key.endsWith("3w")) {
      title = key.startsWith("h") ? "RES5" : "SUP5";
    } else if (key.endsWith("4w")) {
      title = key.startsWith("h") ? "RES6" : "SUP6";
    }

    return { color, title };
  }
  getHistogramColor(value, status) {
    if (value >= 0 && status == "UP") {
      return "#22AB94";
    } else if (value >= 0 && status == "DOWN") {
      return "#ACE5DC";
    } else if (value < 0 && status == "UP") {
      return "#FF5252";
    } else if (value < 0 && status == "DOWN") {
      return "#FCCBCD";
    }
  }
  caculateAO(candleData) {
    let data = [];
    for (let i = 0; i < candleData.length; i++) {
      if (candleData[i].open != "") {
        let sma5 = 0,
          sma34 = 0;

        // 5일 이동 평균 계산 (데이터가 부족한 경우, 가능한 범위 내에서 계산)
        let start = Math.max(0, i - 4); // 시작 인덱스가 음수가 되지 않도록 함
        for (let j = start; j <= i; j++) {
          sma5 += candleData[j].open;
        }
        sma5 /= i - start + 1; // 유효한 데이터 개수로 나눔

        // 34일 이동 평균 계산 (데이터가 부족한 경우, 가능한 범위 내에서 계산)
        let start34 = Math.max(0, i - 33);
        for (let j = start34; j <= i; j++) {
          sma34 += candleData[j].open;
        }
        sma34 /= i - start34 + 1; // 유효한 데이터 개수로 나눔

        let ao = sma5 - sma34;
        let time = candleData[i].time;

        data.push({ time: time, value: ao });
      }
    }
    // console.log('data',data);

    return data;
  }
  async getMarkers(kind, markerSeries) {
    let series = markerSeries["series"][0]["name"];
    if (this.markerSar.length < 1) {
      this.markerSar = [];
      let data = await fetchUrl(`/analysis/rsi`, kind);
      for (let i = 0; i < data.length; i++) {
        var sarTime = data[i].time;
        if (data[i].signal == "L") {
          this.markerSar.push({
            time: sarTime,
            position: "aboveBar",
            color: "#00890E",
            shape: "circle",
            text: `${data[i].signal}`,
            id: "sar_green",
            size: 1.5,
          });
        } else if (data[i].signal == "S") {
          this.markerSar.push({
            time: sarTime,
            position: "aboveBar",
            color: "#C11C1C",
            shape: "circle",
            text: `${data[i].signal}`,
            id: "sar_red",
            size: 1.5,
          });
        }
      }
    }
    series.setMarkers(this.markerSar);
  }
  async getSignalMarkers(kind, container, type) {
    // 현재 type none밖에 안씀
    // let initLoad = this[type].length > 0 ? false : true;
    let data = await fetchUrl(`/analysis/signal`, kind);

    let filedGroup = Object.keys(data);

    // Create an array of promises for setting markers
    const promises = filedGroup.map(async (key) => {
      this[key + "Filtered"] = await this.setSignalMarkers(
        data[key],
        this[key]
      );
      // console.log(key, this[key + 'Filtered']);
    });

    // Wait for all promises to complete
    await Promise.all(promises);
    // console.log('promises',promises);

    container.setMarkers(this[type]);

    await this.toggleMarkers(this[type], this[type + "Filtered"], container);
  }
  async setSignalMarkers(array, marker) {
    const filteredArray = array.filter((arr) => !arr.signal.endsWith("B"));
    for (let i = 0; i < filteredArray.length; i++) {
      let signal = filteredArray[i].signal;
      let timestamp = filteredArray[i].time;
      let firstChar = signal.charAt(0);
      let secondChar = signal.charAt(1);
      let lastTwoChars = signal.slice(-2);
      // console.log('signal',signal,'secondChar',secondChar);
      if (firstChar == "L") {
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            // shape: 'arrowUp',
            text: `▲${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            // shape: 'arrowUp',
            text: `▲`,
            size: 1,
          });
        } else if (secondChar == "4") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#7DCD5D",
            // shape: "arrowUp",
            text: `▲`,
            size: 1,
          });
        } else if (secondChar == "R") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#7DCD5D",
            shape: "arrowUp",
            text: `${secondChar}L`,
            size: 2,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#7DCD5D",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        }
      } else if (firstChar == "S") {
        //S
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#e91e63",
            shape: "arrowDown",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#E00094",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#C11C1C ",
            // shape: 'arrowDown',
            text: `▼${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#C11C1C",
            // shape: 'arrowDown',
            text: `▼`,
            size: 1,
          });
        } else if (secondChar == "4") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "red",
            // shape: "arrowDown",
            text: `▼`,
            size: 1,
          });
        } else if (secondChar == "R") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#FFF100",
            shape: "arrowDown",
            text: `${secondChar}S`,
            size: 2,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "red",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        }
      }
    }
    // return marker.filter((item) => !/\d$/.test(item.text));

    return marker.filter((item) => {
      const text = item.text;
      const secondChar = text[1]; // 두 번째 문자 (index 1)
      return !/\d$/.test(text) && secondChar !== "4";
    });
  }
  async setRLSSignalMarkers(array, marker) {
    for (let i = 0; i < array.length; i++) {
      let signal = array[i].signal;

      let timestamp = array[i].time;
      let firstChar = signal.charAt(0);
      let secondChar = signal.charAt(1);

      if (firstChar == "L") {
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            // shape: 'arrowUp',
            text: `▲${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#03C988",
            shape: "arrowUp",
            text: `${signal}`,
            size: 1.5,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "belowBar",
            color: "#7DCD5D",
            shape: "arrowUp",
            text: secondChar,
            size: 1.5,
          });
        }
      } else if (firstChar == "S") {
        //S
        if (secondChar == "V") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#e91e63",
            shape: "arrowDown",
            text: "🚀",
            size: 1.5,
          });
        } else if (secondChar == "B") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#E00094",
            shape: "arrowDown",
            text: signal,
            size: 1.5,
          });
        } else if (secondChar == "D") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#C11C1C ",
            // shape: 'arrowDown',
            text: `▼${signal}`,
            size: 1,
          });
        } else if (secondChar == "") {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#C11C1C ",
            shape: "arrowDown",
            text: `${signal}`,
            size: 1.5,
          });
        } else {
          marker.push({
            time: timestamp,
            position: "aboveBar",
            color: "#FFF100",
            shape: "arrowDown",
            text: secondChar,
            size: 1.5,
          });
        }
      }
    }
    // 문자도 같이 깜빡임
    //  rls 체크했을때 r , 4 랑 원래 있던 시그널들 같이 표시하는데 토글은 숫자있는 애들만 깜빡?
    return marker.filter((item) => !/\d$/.test(item.text));
  }
  // async toggleMarkers(original, filtered, container) {
  //   if (window.markerInterval) {
  //     clearInterval(window.markerInterval);
  //   }
  //   if (window.globalAnimationSignal === undefined) {
  //     window.globalAnimationSignal = false;

  //     window.globalToggleInterval = setInterval(function () {
  //       window.globalAnimationSignal = !window.globalAnimationSignal;
  //       // console.log("Toggle state changed:", window.globalAnimationSignal);
  //     }, 500);
  //   }
  //   window.markerInterval = setInterval(function () {
  //     if (window.globalAnimationSignal) {
  //       container.setMarkers(filtered);
  //       console.log(filtered);
  //     } else {
  //       // 숫자만 나옴
  //       container.setMarkers(original); // noneArray로 마커 설정
  //       console.log(original);
  //     }
  //   }, 300);
  // }

  //   async toggleMarkers(originalMarkers, filteredMarkers, container) {
  //   // 기존 인터벌 정리
  //   if (this.markerInterval) {
  //     clearInterval(this.markerInterval);
  //     this.markerInterval = null;
  //   }

  //   let isTransparent = false;

  //   this.markerInterval = setInterval(() => {
  //     isTransparent = !isTransparent;

  //     // 현재 활성화된 마커 선택 (필터링된 마커 or 원본 마커)
  //     const activeMarkers = window.globalAnimationSignal ? filteredMarkers : originalMarkers;

  //     // 색상 토글된 새 마커 배열 생성
  //     const newMarkers = activeMarkers.map(marker => ({
  //       ...marker,
  //       color: isTransparent ? 'transparent' : marker.originalColor // 원본 색상 유지
  //     }));

  //     container.setMarkers(newMarkers);
  //   }, 300);
  // }

  async toggleMarkers(original, filtered, container) {
    if (window.markerInterval) {
      clearInterval(window.markerInterval);
    }
    if (window.globalAnimationSignal === undefined) {
      window.globalAnimationSignal = false;
      window.globalToggleInterval = setInterval(function () {
        window.globalAnimationSignal = !window.globalAnimationSignal;
      }, 500);
    }

    window.markerInterval = setInterval(function () {
      const filteredIds = new Set(filtered.map((m) => m.text));

      const toggledMarkers = original.map((marker) => {
        if (!filteredIds.has(marker.text)) {
          // filtered에 없는 경우: color를 투명하게
          return {
            ...marker,
            color: window.globalAnimationSignal
              ? "rgba(0,0,0,0)"
              : marker.color, // 투명 or 원래색
          };
        } else {
          // filtered에 있는 경우: 원본 marker 그대로
          return marker;
        }
      });

      container.setMarkers(toggledMarkers);
      // console.log(toggledMarkers);
    }, 500);
  }

  setPriceScale(checkedList, priceScaleObj, chartContainer) {
    let rsiChecked = checkedList.includes("RSI");
    let macdChecked = checkedList.includes("MACD");

    let applyPriceScale = (
      seriesList,
      scaleId,
      top,
      bottom,
      rsiTop,
      rsiBottom
    ) => {
      seriesList.forEach((series) => {
        if (series["key"] == "rsi") {
          this.priceScaleMethod(series["name"], "rsi", rsiTop, rsiBottom);
        } else {
          this.priceScaleMethod(series["name"], scaleId, top, bottom);
        }
      });
    };

    if (macdChecked && rsiChecked) {
      applyPriceScale(priceScaleObj["MACD"].series, "macd", 0.6, 0.2);
      applyPriceScale(
        priceScaleObj["RSI"].series,
        "macdrsi",
        0.1,
        0.5,
        0.8,
        0.05
      );
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.5);
    } else if (macdChecked && !rsiChecked) {
      applyPriceScale(priceScaleObj["MACD"].series, "macd", 0.6, 0.1);
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.5);
    } else if (!macdChecked && rsiChecked) {
      applyPriceScale(
        priceScaleObj["RSI"].series,
        "macdrsi",
        0.2,
        0.45,
        0.7,
        0.05
      );
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.4);
    } else if (!macdChecked && !rsiChecked) {
      this.priceScaleMethod(chartContainer, "right", 0.1, 0.3);
    }
  }
  priceScaleMethod(series, scaleId, top, bottom) {
    series.priceScale(scaleId).applyOptions({
      scaleMargins: {
        top: top,
        bottom: bottom,
      },
    });
  }
  displayCheckStatus(chartTabIndex, checkedList, fetchList) {
    let isHeikin = checkedList.includes("HEI");
    let allChecked = checkedList.includes("All");
    // let macdChecked = checkedList.includes('MACD')
    let includeLength = checkedList.filter(
      (chk) => chk == "RSI" || chk == "MACD"
    ).length;
    let aoSeries = this.getSeries(fetchList, "AO").series[0].name;
    // console.log('allChecked',allChecked,'includeLength',includeLength,'macdChecked',macdChecked);
    // console.log('chartTabIndex',chartTabIndex);

    // rsi,macd,ao series display status
    if (chartTabIndex == "pro") {
      // console.log('allCheckd',allChecked,checkedList);
      if (allChecked) {
        aoSeries.setData([]);
      } else if (!allChecked && includeLength > 0) {
        aoSeries.setData([]);
      } else {
        isHeikin ? aoSeries.setData(this.aoHei) : aoSeries.setData(this.ao);
      }
    } else if (chartTabIndex == "lite") {
      aoSeries.setData(this.ao);
    }
    // console.log('this.ao',this.ao);
  }
  getSeries(obj, id) {
    return obj.find((el) => el.key == id);
  }

  async getRLSSignalMarkers(
    kind,
    container,
    type,
    checked,
    forceUpdate = false
  ) {
    // 로직 : rls 체크시 기존 시그널이랑 rls 시그널 같이 나와야함
    //  => rls api 불러와서 setRLS에서 필터링 가져옴
    //  => rls_none : 기존 시그널 + rls 시그널
    //  => rls_none_Filtered : 기존시그널 필터링 + rls 시그널 필터링 ( 필터링 기준: 숫자 없는 문자들 )

    try {
      if (checked) {
        if (this["rls_" + type].length <= 0 || forceUpdate) {
          const labelmarkersTest = await getLabelSignalTest(kind);
          const rlsmarkersTest = await getRlsSignalTest(kind);

          let labelFieldGroup = Object.keys(labelmarkersTest);
          let rlsFieldGroup = Object.keys(rlsmarkersTest);

          const allFieldGroup = [
            ...new Set([...labelFieldGroup, ...rlsFieldGroup]),
          ];

          const promises = allFieldGroup.map(async (key) => {
            if (labelmarkersTest[key]) {
              // filtered - 순수문자열
              this["rls_" + key + "Filtered"] = await this.setSignalMarkers(
                labelmarkersTest[key],
                this["rls_" + key]
              );
            }
            if (rlsmarkersTest[key]) {
              // filtered - 순수문자열
              this["rls_" + key + "Filtered"] = await this.setSignalMarkers(
                rlsmarkersTest[key],
                this["rls_" + key]
              );
            }
          });

          await Promise.all(promises);

          if (Array.isArray(this["rls_" + type])) {
            //  중복 제거 : concat 후 map -> Map 으로 중복 제거
            const mergedMarkers = [...this["rls_" + type], ...this.none];

            const mergedFilteredMarkers = [
              ...this["rls_" + type + "Filtered"],
              ...this.noneFiltered,
            ];

            //  time이랑 text모두 똑같아야 중복 제거
            // this["rls_" + type] = Array.from(
            //   new Map(mergedMarkers.map((m) => [m.time, m])).values()
            // );

            // this["rls_" + type + "Filtered"] = Array.from(
            //   new Map(mergedFilteredMarkers.map((m) => [m.time, m])).values()
            // );

            this["rls_" + type] = Array.from(
              new Map(
                mergedMarkers.map((m) => [`${m.time}_${m.text}`, m])
              ).values()
            );

            this["rls_" + type + "Filtered"] = Array.from(
              new Map(
                mergedFilteredMarkers.map((m) => [`${m.time}_${m.text}`, m])
              ).values()
            );

            // 정렬
            this["rls_" + type].sort((a, b) => a.time - b.time);
            this["rls_" + type + "Filtered"].sort((a, b) => a.time - b.time);
          }
        }

        await this.toggleMarkers(
          this["rls_" + type], // 원래 시그널 마커 + rls 마커
          this["rls_" + type + "Filtered"], // rls 필터된 마커만 들어가있음
          container
        );
      } else {
        await this.toggleMarkers(
          this[type],
          this[type + "Filtered"],
          container
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getRLSLineData(kind, container, checked, forceUpdate = false) {
    try {
      if (!this.highLowLine) {
        this.highLowLine = []; // 초기화
      }

      if (checked) {
        if (this.highLowLine.length === 0 || forceUpdate) {
          // 시리즈가 없거나 강제 업데이트일 때만 새로 만듦
          if (forceUpdate) {
            this.highLowLine.forEach(({ series }) => {
              container.removeSeries(series);
            });
            this.highLowLine = []; // 완전 초기화
          }

          const highList = await getHighLineTest(kind);
          const lowList = await getLowLineTest(kind);

          const lineOptions = [
            {
              option: pmChartInstance.highestOption,
              data: highList.highest_high,
            },
            {
              option: pmChartInstance.secondHighestOption,
              data: highList.second_highest_close,
            },
            {
              option: pmChartInstance.upperLineOption,
              data: highList.upper_line,
            },
            { option: pmChartInstance.lowestOption, data: lowList.lowest_low },
            {
              option: pmChartInstance.secondLowestOption,
              data: lowList.second_lowest_close,
            },
            {
              option: pmChartInstance.lowerLineOption,
              data: lowList.lower_line,
            },
          ];

          lineOptions.forEach(({ option, data }) => {
            //  한 번만 addLineSeries 호출
            const series = container.addLineSeries(option);

            const formattedData = Array.from(
              new Map(
                data.map(({ value, time }) => [
                  Number(time),
                  { value, time: Number(time) },
                ])
              ).values()
            );

            this.highLowLine.push({ series, data: formattedData }); // 저장
            series.setData(formattedData);
          });
        } else {
          // 시리즈가 이미 있으면 새로 만들지 말고 데이터만 세팅
          this.highLowLine.forEach(({ series, data }) => {
            series.setData(data);
          });
        }
      } else {
        // 체크 해제면 모든 시리즈를 빈 데이터로
        this.highLowLine.forEach(({ series }) => {
          series.setData([]);
        });
      }
    } catch (error) {
      console.error("line data 오류", error);
    }
  }
}
